import { createContext, useContext } from "react";
import { AUTOPLAY_INIT_VALUE } from "../../hooks/useAutoplay/constants";

export const AutoplayContext = createContext({
  autoplayState: AUTOPLAY_INIT_VALUE,
  updateAutoplayState: () => {},
  isMotionReduced: false
});

export const useAutoplayContext = () => useContext(AutoplayContext);
